import Vue from 'vue'
import Router from 'vue-router'

import Dashboard from './component/Dashboard.vue'
import Users from './component/Users.vue'
import Shows from './component/Shows.vue'
import Show from './component/Show.vue'
import Tickets from './component/Tickets.vue'
import Validator from './component/Validator.vue'
import Borderos from './component/Borderos.vue'
import Bordero from './component/Bordero.vue'
import Settings from './component/Settings.vue'
import Sales from './component/Sales.vue'
import TicketTypes from './component/TicketTypes.vue'
import TicketBook from './component/TicketBook.vue'
import Info from './component/Info.vue'
import Financial from './component/Financial.vue'
import Finances from './component/Finances.vue'
import Festivals from './component/Festivals.vue'
import ShowCase from './component/ShowCase.vue'
import Invitations from './component/Invitations.vue'
import Producers from './component/Producers.vue'
import EducationalVideos from './component/EducationalVideos.vue'

Vue.use(Router)

export default new Router({
  mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard',
      name: 'main',
      component: Dashboard
    },
    {
      path: '/usuario',
      name: 'user',
      component: Users
    },
    {
      path: '/showcase',
      name: 'showcase',
      component: ShowCase
    },
    {
      path: '/usuario/:id',
      name: 'user-id',
      component: Users,
      props: true
    },
    {
      path: '/event',
      name: 'show',
      component: Shows
    },
    {
      path: '/event/:id',
      name: 'show-id',
      component: Show,
      props: true
    },
    {
      path: '/festival',
      name: 'festival',
      component: Festivals
    },
    {
      path: '/festival/:id',
      name: 'festival-id',
      component: Festivals,
      props: true
    },
    {
      path: '/event/:id/expense',
      name: 'show-expense',
      component: Shows,
      props: true
    },
    {
      path: '/ticket',
      name: 'ticket',
      component: Tickets
    },
    {
      path: '/ticket/:showDate/:seat/:type',
      name: 'ticket-id',
      component: Tickets,
      props: true
    },
    {
      path: '/validator',
      name: 'validator',
      component: Validator
    },
    {
      path: '/bordero',
      name: 'bordero',
      component: Borderos
    },
    {
      path: '/bordero/:id',
      name: 'bordero-id',
      component: Bordero,
      props: true
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/educational-video',
      name: 'educational-videos',
      component: EducationalVideos
    },
    {
      path: '/educational-video/:id',
      name: 'educational-video',
      component: EducationalVideos,
      props: true
    },
    {
      path: '/sales',
      name: 'sales',
      component: Sales
    },
    {
      path: '/ticket-type',
      name: 'ticket-types',
      component: TicketTypes
    },
    {
      path: '/ticket-type/:id',
      name: 'ticket-type-id',
      component: TicketTypes,
      props: true
    },
    {
      path: '/ticket-book',
      name: 'ticket-book',
      component: TicketBook
    },
    {
      path: '/info',
      name: 'info',
      component: Info
    },
    {
      path: '/financial',
      name: 'financial',
      component: Financial
    },
    {
      path: '/finances',
      name: 'finance',
      component: Finances
    },
    {
      path: '/invitation',
      name: 'invitation',
      component: Invitations
    },
    {
      path: '/invitation/:id',
      name: 'invitation-id',
      component: Invitations,
      props: true
    },
    {
      path: '/producer',
      name: 'producer',
      component: Producers
    },
    {
      path: '/producer/:id',
      name: 'producer-id',
      component: Producers,
      props: true
    }
  ]
})
